import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { isEmpty } from 'lodash';

import Definition from '../../../shared/Definition';
import { OwnerLink } from '../../../shared/links/ProfileLink';
import { formatDate } from '../../../utils/date';

const previousOwner = owner => (
    <li key={shortid.generate()}>
        {owner.ownerStyleName} until {formatDate(owner.ownerChangeDate, 'D MMM YYYY')}
    </li>
);

const Owner = ({ ownerName, ownerUid, hasPedigree, previousOwners, isWeatherbysMobile }) => {
    if (isWeatherbysMobile) {
        return (
            ownerUid ? (
                <Definition term="">
                    <OwnerLink
                        ownerStyleName={ownerName}
                        ownerUid={ownerUid}
                    />
                </Definition>
            ) : null
        );
    }

    return (
        ownerUid ? (
            <Definition term={`${hasPedigree ? 'Racing ' : ''}Owner`}>
                <OwnerLink
                    ownerStyleName={ownerName}
                    ownerUid={ownerUid}
                />
                {!isEmpty(previousOwners) && (
                    <ul className="hp-details__owners-list">
                        {previousOwners.map(previousOwner)}
                    </ul>
                )}
            </Definition>
        ) : null
    );
};

Owner.propTypes = {
    ownerName: PropTypes.string,
    ownerUid: PropTypes.number,
    hasPedigree: PropTypes.bool,
    isWeatherbysMobile: PropTypes.bool,
    previousOwners: PropTypes.arrayOf(PropTypes.shape({
        ownerChangeDate: PropTypes.string,
        ownerStyleName: PropTypes.string,
    })),
};

export default Owner;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Owner.jsx